var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsCounterClockwise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23438 7.78906H2.48438V4.03906",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8594 5.14038C14.2216 4.50165 13.4641 3.99492 12.6303 3.64918C11.7965 3.30345 10.9027 3.12549 10 3.12549C9.09735 3.12549 8.20355 3.30345 7.36973 3.64918C6.53591 3.99492 5.77843 4.50165 5.14063 5.14038L2.48438 7.78882",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7656 12.2109H17.5156V15.9609",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14062 14.8594C5.77843 15.4981 6.53591 16.0048 7.36973 16.3506C8.20355 16.6963 9.09735 16.8743 10 16.8743C10.9027 16.8743 11.7965 16.6963 12.6303 16.3506C13.4641 16.0048 14.2216 15.4981 14.8594 14.8594L17.5156 12.2109",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsCounterClockwise);
export default __webpack_public_path__ + "static/media/ArrowsCounterClockwise.dac96987fc08017454ed4a8a8e7ca1d9.svg";
export { ForwardRef as ReactComponent };